import { DataService } from "./DataService.js";
import { ChunkDataService, chunkDataServiceConf } from "./export.js";



//TODO processRequestedApp should be checked that all code is ok !!!!!!!!!!!!!!!! Ive not ended checking

export class AppDataService extends DataService {
    //interface for indexeddb and http services

    constructor(req, conf, gudhub) {
        super();
        this.chunkDataService = new ChunkDataService(req, chunkDataServiceConf, gudhub);
        this.gudhub = gudhub;
    }


    isWithCache() {
        return false;
    }


    //here
    async processRequestedApp(id, sentData) {


        // let 


        // let chunksHashesToLoad = sentData.chunks;

        // let chunks = [];


        // if (
        //     this.chunkDataService.isWithCache()
        // ) {

        //     let cachedMergedChunkData = this.chunkDataService.getCached(id);

        // }


        
        // all implementations are without cache for now
        if (
            !this.isWithCache()
        ) {


            // let resultedMergedChunks = this.chunkDataService.getMergedChunk(id, sentData.chunks);


            ///TODO here chunks could be with cache too

//   async getChunks(app_id, chunk_ids) {
//     let chunks = [];
//     if(chunk_ids){
//       chunks = await Promise.all(chunk_ids.map((chunk_id) => this.getChunk(app_id, chunk_id)));
//     }
//     return chunks;
//   }

            // let res = await this.chunkDataService.getChunks(id, sentData.chunks);
            // let res = await Promise.all(sentData.chunks.map((chunk_id) => this.chunkDataService.getChunk(id, chunk_id)));

            let res = await this.chunkDataService.getMergedChunkForIDList(id, sentData.chunks);


            if (
                res
            ) {
                sentData.items_list = await this.gudhub.util.mergeChunks([
                    res,
                    sentData,
                ]);
            }

            // if (!res) res = [];



            //TODO should be in new thread too even for Node.js becauses this will block loop

            // sentData.items_list = await this.gudhub.util.mergeChunks([
            //     ...res,
            //     sentData,
            // ]);


            return sentData;
  
        //   this.dataService.putApp(id, nextVersion);


            // return this.mergeAndReturnStrategy.handle(sentData, chunks);



        }



        throw new Error;






        try {

            // я там собираюсь склеивать все данные в этом методе, надо посмотреть не будет ли проблем для ноды итп там тоже process вызывается
            let cachedApp = await this.getCached(id); // this should be merged chunk + app from db


            // if (
            //     this.chunkDataService.isWithCache()
            // ) {
            //     let cachedMergedChunk = this.chunkDataService.getCached();
            // }


            // let res = await this.chunkDataService.getMergedChunkForIDList(id, sentData.chunks);



            // let cachedMergedChunk = await this.chunkDataService.getCachedMergedChunk(id, cachedApp.chunks);

            if (
                !cachedApp
                // cachedMergedChunk ?
            ) {

                //TODO maybe dont wait for chunks at first load

                // let res = await this.chunkDataService.getChunks(id, sentData.chunks);
                // let res = await Promise.all(sentData.chunks.map((chunk_id) => this.chunkDataService.getChunk(id, chunk_id)));
                let res = await this.chunkDataService.getMergedChunkForIDList(id, sentData.chunks);


                if (
                    res
                ) {
                    sentData.items_list = await this.gudhub.util.mergeChunks([
                        res,
                        sentData,
                    ]);
                }

                // this.putInCache(id, sentData);
    
    
                return sentData;
            }


            // let newHashesList = sentData.chunks.filter(c => !cachedApp.chunks.includes(c));


            // let self = this;


            // let res = await this.chunkDataService.getChunks(id, newHashesList);
            // let res = await Promise.all(newHashesList.map((chunk_id) => this.chunkDataService.getChunk(id, chunk_id)));

            let res = await this.chunkDataService.getCachedMergedChunk(id, cachedApp.chunks);

            // if (!res) res = [];



            if (
                res
            ) {
                sentData.items_list = await this.gudhub.util.mergeChunks([
                    cachedApp,
                    res,
                    sentData,
                ]);
            } else {
                sentData.items_list = await this.gudhub.util.mergeChunks([
                    cachedApp,
                    sentData,
                ]);
            }




            // this.chunkDataService.getChunks(id, newHashesList).then((res) => {





                //TODO check this for AppHttpService, seems isnt necessary
                // this.gudhub.triggerAppChange(id, cachedVersion, sentData);


                // self.putInCache(id, sentData);
            // });


                return sentData;



            // return cachedVersion;
            
        } catch (error) {

            // seems try catch here isnt handling almost anything, almost identical code here

            // res = await this.chunkDataService.getChunks(id, sentData.chunks);
            // let res = await Promise.all(sentData.chunks.map((chunk_id) => this.chunkDataService.getChunk(id, chunk_id)));
            let res = await this.chunkDataService.getMergedChunkForIDList(sentData.chunks);

            // if (!res) res = [];


            if (
                res
            ) {
                sentData.items_list = await this.gudhub.util.mergeChunks([
                    res,
                    sentData,
                ]);
            }

            // this.putInCache(id, sentData);


            return sentData;
        }
    }
}